import * as sagaEffects from 'redux-saga/effects';

export function genState() {
    return {
        '@@tags': {}
    };
}

export function genReducers() {
    return {
        __privateAddTag(state, { payload }) {
            const { tagName, tagInitState } = payload;

            if (state['@@tags'][tagName]) {
                throw new Error(`VM中已存在名为${tagName}的标签，请检查！`);
            }

            return {
                ...state,
                '@@tags': {
                    ...state['@@tags'],
                    [tagName]: tagInitState
                }
            };
        },
        __privateRemoveTag(state, { payload }) {
            const { tagName } = payload;

            let newTags = { ...state['@@tags'] };
            delete newTags[tagName];

            return {
                ...state,
                '@@tags': newTags
            };
        }
    };
}

export function wrapTagApis(bizModelNamespace, tagName, apis) {
    function invokeEffectOrReducer(effectOrReducerName, payload) {
        return wrapTagAction(bizModelNamespace, tagName, effectOrReducerName, payload);
    }

    const o = apis(invokeEffectOrReducer);

    return Object.keys(o).reduce((acc, apiName) => {
        acc[apiName] = function*(...args) {
            const ret = o[apiName](...args);
            if (ret && ret.type && ret.payload) {
                return yield yield sagaEffects.put(ret);
            } else {
                return ret;
            }
        };
        return acc;
    }, {});
}

export function wrapTagEffects(effects) {
    const o = effects();

    return Object.keys(o).reduce((acc, effectName) => {
        acc[effectName] = function*({ payload: { tagName, payload } }, RUI) {
            // 这个 getState 是提供给标签用的
            // 直接获取标签内部的 state 数据，而无需关注数据存在哪
            function* getState() {
                const bizVMState = yield RUI.getState();
                return selectTagStateFromBizVMState(bizVMState, tagName);
            }

            function* invoke(effectOrReducerName, payload) {
                return yield RUI.invoke(effectOrReducerName, {
                    tagName,
                    payload
                });
            }

            return yield yield o[effectName](
                { payload },
                {
                    ...RUI,
                    getState,
                    invoke
                }
            );
        };
        return acc;
    }, {});
}

export function wrapTagReducers(reducers) {
    const o = reducers();

    return Object.keys(o).reduce((acc, reducerName) => {
        acc[reducerName] = (state, { payload }) => {
            return proxyReducer(state, payload, o[reducerName]);
        };

        return acc;
    }, {});
}

/**
 * 业务模型空间名称
 * 标签名
 * 函数名
 * 参数
 */
export function wrapTagAction(bizVMNamespace, tagName, effectOrReducerFnName, payload) {
    return {
        type: `${bizVMNamespace}/${effectOrReducerFnName}`,
        payload: {
            tagName,
            payload
        }
    };
}

export function proxyReducer(bizVMState, wrappedPayload, tagReducer) {
    const { tagName, payload } = wrappedPayload;

    return {
        ...bizVMState,
        '@@tags': {
            ...bizVMState['@@tags'],
            [tagName]: tagReducer(bizVMState['@@tags'][tagName], { payload })
        }
    };
}

export function selectTagStateFromBizVMState(bizVMState, tagName) {
    return bizVMState['@@tags'][tagName];
}
